/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is the sort stable?`)
};

const es_ls_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es estable la clasificación?`)
};

const de_ls_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist die Sortierung stabil?`)
};

const nl_ls_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is de sortering stabiel?`)
};

const fr_ls_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tri est-il stable ?`)
};

const it_ls_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ordinamento è stabile?`)
};

const pt_br2_ls_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ordenação é estável?`)
};

const pt_ls_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A classificação é estável?`)
};

const ja_ls_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソートは安定していますか?`)
};

const zh_ls_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排序是稳定的吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_faq2_q", locale)
	if (locale === "en") return en_ls_faq2_q(inputs)
	if (locale === "es") return es_ls_faq2_q(inputs)
	if (locale === "de") return de_ls_faq2_q(inputs)
	if (locale === "nl") return nl_ls_faq2_q(inputs)
	if (locale === "fr") return fr_ls_faq2_q(inputs)
	if (locale === "it") return it_ls_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_ls_faq2_q(inputs)
	if (locale === "pt") return pt_ls_faq2_q(inputs)
	if (locale === "ja") return ja_ls_faq2_q(inputs)
	return zh_ls_faq2_q(inputs)
};